import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGroups = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Primary",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		id: "Path_399",
		"data-name": "Path 399",
		d: "M1136.032,101.469c.119.046.236.094.355.138a1.817,1.817,0,0,1,1.2,1.828,1.78,1.78,0,0,1-1.451,1.626.565.565,0,0,0-.506.435c-.355,1.06-.731,2.113-1.113,3.164a.379.379,0,0,0,.112.5,2.02,2.02,0,0,1,.714,1.776.357.357,0,0,0,.244.416c.519.244,1.037.493,1.54.768a.419.419,0,0,0,.571-.072,1.764,1.764,0,0,1,2.177-.108,1.8,1.8,0,1,1-2.772,1.95.435.435,0,0,1-.037-.189c.142-.609-.265-.8-.717-.994-.4-.168-.768-.39-1.163-.56a.494.494,0,0,0-.35.069c-.1.051-.156.192-.258.234-.576.234-.561.686-.528,1.2.089,1.386.131,2.777.192,4.181.123.025.223.044.321.067a1.807,1.807,0,0,1,.3,3.446c-.081.036-.159.08-.237.121h-.864a1.952,1.952,0,0,1-1.343-1.441,1.717,1.717,0,0,1,.655-1.766.557.557,0,0,0,.244-.519q-.108-2.223-.187-4.446c-.009-.213-.06-.319-.3-.353a2.083,2.083,0,0,1-1.618-1.162.3.3,0,0,0-.42-.193c-1.064.262-2.135.491-3.2.759a.677.677,0,0,0-.4.34,1.829,1.829,0,0,1-1.97,1.147,1.8,1.8,0,0,1-1.54-1.717,1.825,1.825,0,0,1,1.294-1.8,1.782,1.782,0,0,1,2.115.914c.11.213.213.278.448.221q1.539-.379,3.085-.725a.434.434,0,0,0,.392-.392,2.149,2.149,0,0,1,2.233-1.738.392.392,0,0,0,.469-.322c.349-1.034.719-2.062,1.09-3.089.064-.178.08-.3-.1-.429a1.709,1.709,0,0,1-.691-1.861,1.727,1.727,0,0,1,1.406-1.36.768.768,0,0,0,.138-.066Z",
		transform: "translate(-1120.681 -99.469)"
	}), /* @__PURE__ */ _jsx("rect", {
		id: "BoundingBox",
		width: 24,
		height: 24,
		fill: "rgba(255,255,255,0)"
	})]
});
export default SvgGroups;
